const pom = {
  general: {
    reactModalContent: "[data-testid='react-modal-content']",
    itemName: "[data-testid='item-name']",
  },
  header: {
    merchantLogo: "merchant logo", // for alt attribute
    merchantLogoDataTestId: "[data-testid='merchant-logo']", // for data-testid
    merchantLogoAlt: `[alt="${"merchant logo"}"]`, // for cypress selector
    navigationBar: "[data-testid='navigation-bar']",
    cartNumber: "[data-testid='cart-number']",
    searchInputField: "[data-testid='input-search']",
    searchIcon: "[data-testid='search-icon']",
    merchantName: "[data-testid='merchant-name']",
    dismissCookieBanner: "[data-testid='dismiss-cookie-banner']",
  },
  footer: {
    cloverFooter: "[data-testid='clover-footer']",
    googlePlayButton: "[alt='Google Play Button']",
    appStoreButton: "[alt='App Store Button']",
    footer: "[data-testid='footer']",
    description: "[data-testid='footer-description']",
    contactInfo: "[data-testid='contact-info']",
    businessHours: "[data-testid='business-hours']",
  },
  merchantFooter: {
    merchantFooter: "[data-testid='merchant-footer']",
    businessLocationsSection: "[data-testid='business-locations-section']",
    operatingHoursSection: "[data-testid='operating-hours-section']",
    linksSection: "[data-testid='links-section']",
    map: "[data-testid='google-map']",
    socialMediaLinks: "[data-testid='social-media-links']",
  },
  utilities: {
    buttonByText: (text: string) => `button:contains('${text}')`,
    linkByText: (text: string) => `a:contains('${text}')`,
  },
  landingPage: {
    heroSection: "[data-testid='hero-section']",
    heroImage: "[data-testid='hero-image']",
    heroHeadline: "[data-testid='hero-headline']",
    heroSectionButton: "[data-testid='hero-section'] button",
    productListing: "[data-testid='item-list']",
    productCardName: "[data-testid='product-card-name']",
    productCardImage: "[data-testid='product-card-image']",
    orderTypeDropdown: "[data-testid='order-type-dropdown']",
    scheduledOrderDropdown: "[data-testid='scheduled-order-dropdown']",
    cartIcon: "[data-testid='cart-icon']",
    productLink: "[data-testid^='product-link-']",
    addToOrderButton: "[data-testid='add-to-order-button']",
    productsSkeleton: "[data-testid='products-skeleton']",
    itemPageSkeleton: "[data-testid='item-page-skeleton']",
    heroTitle: "[data-testid='hero-title']",
    heroDescription: "[data-testid='hero-description']",
    categoriesSection: "[data-testid='categories-section']",
    category: (categoryName: string) =>
      `[data-testid='category-${categoryName}']`,
    itemsSection: "[data-testid='items-section']",
    item: (itemName: string) => `[data-testid='item-${itemName}']`,
    servicesSection: "[data-testid='services-section']",
    bookNowButton: "[data-testid='book-now-button']",
    viewMenuButton: "[data-testid='view-menu-button']",
    aboutUsSection: "[data-testid='about-us-section']",
    aboutUsTitle: "[data-testid='about-us-title']",
    aboutUsDescription: "[data-testid='about-us-description']",
    aboutUsImage: "[data-testid='about-us-image']",
    contactUsSection: "[data-testid='contact-us-section']",
    contactUsTitle: "[data-testid='contact-us-title']",
    contactUsDescription: "[data-testid='contact-us-description']",
    contactUsForm: "[data-testid='contact-us-form']",
    contactUsMap: "[data-testid='contact-us-map']",
    gallerySection: "[data-testid='gallery-section']",
    galleryTitle: "[data-testid='gallery-title']",
    galleryDescription: "[data-testid='gallery-description']",
    galleryImages: "[data-testid='gallery-images']",
    testimonialsSection: "[data-testid='testimonials-section']",
    testimonialsTitle: "[data-testid='testimonials-title']",
    testimonialsDescription: "[data-testid='testimonials-description']",
    testimonials: "[data-testid='testimonials']",
  },
  orderTypeOption: (type: string) =>
    `[data-testid='order-type-option-${type}']`,
  banners: {
    doubleCheckOrderBanner: "[data-testid='double-check-order-banner']",
    doubleCheckOrderText: "[data-testid='double-check-order-text']",
    notAcceptingOrderBanner: "[data-testid='not-accepting-order-banner']",
  },
  icons: {
    bulletPointIcon: "[data-testid='bullet-point-icon']",
    xIcon: "[data-testid='x icon']",
    doubleCheckOrderIcon: "[data-testid='double-check-order-icon']",
    minusIcon: "[data-testid='minus-icon']",
    plusIcon: "[data-testid='plus-icon']",
    profileIcon: "[data-testid='profile-icon']",
    sendCodeIcon: "[data-testid='send-code-icon']",
    serviceSummaryErrorIcon: "[data-testid='service-summary-error-icon']",
    trashIcon: "[data-testid='trash-icon']",
    accountIcon: "[data-testid='account-icon']",
  },
  checkout: {
    checkoutHeader: "[data-testid='checkout-header']",
    perkCardApplied: "[data-testid='perk-card-applied']",
    toolTipBox: "[data-testid='toolTipBox']",
    toolTipIcon: "[data-testid='toolTipIcon']",
  },
  customerProfile: {
    notCompleteCustomerInfoBanner:
      "[data-testid='not-complete-customer-info-banner']",
    customerProfileHeader: "[data-testid='customer-profile-header']",
  },
  skeletons: {
    navBarSkeleton: "[data-testid='nav-bar-skeleton']",
    allSkeletons: "[data-testid$='-skeleton']",
  },
  modals: {
    loginModalCloseButton: "[data-testid='login-modal-close-button']",
    secondaryButton: "[data-testid='secondary-button']",
    closeButton: "[data-testid='close-button']",
    loginModalSwitchInput: "[data-testid='login-modal-switch-input-method']",
  },
  scanToOrder: {
    itemsAddedToCartBanner: "[data-testid='items-added-to-cart-banner']",
    runningTabsWelcomeModal: "[data-testid='running-tabs-welcome-modal']",
    runningTabsWelcomeModalHeader:
      "[data-testid='running-tabs-welcome-modal-header']",
    runningTabsWelcomeModalText:
      "[data-testid='running-tabs-welcome-modal-text']",
    scanToOrderCartHeader: "[data-testid='scan-to-order-cart-header']",
    scanToOrderCartTableInfo: "[data-testid='scan-to-order-cart-table-info']",
    sendToKitchenButton: "[data-testid='send-to-kitchen-button']",
    tableInfoItem: "[data-testid='table-info-item']",
    cartItemModifierList: "[data-testid='cart-item-modifier-list']",
  },
  products: {
    productPrice: "[data-testid='product-price']",
    singleProduct: "[data-testid='single-product']",
    productDescription: "[data-testid='product-description']",
    giftCardImage: "[data-testid='gift-card-image']",
    serviceDuration: "[data-testid='service-duration']",
  },
  verifyEmail: {
    verifyEmailHeader: "[data-testid='verify-email-header']",
  },
  scheduler: {
    avatar: "[data-testid='avatar']",
  },
  itemPage: {
    modifierInput: "[data-testid^='modifier-input-']", // Use starts-with selector
    quantityStepper: (modifierName: string) =>
      `[data-testid='quantity-stepper-${modifierName}']`,
    quantityInput: (modifierName: string) =>
      `[data-testid='quantity-stepper-${modifierName}'] input`,
    incrementButton: (modifierName: string) =>
      `[data-testid='quantity-stepper-${modifierName}'] button:last-child`,
    decrementButton: (modifierName: string) =>
      `[data-testid='quantity-stepper-${modifierName}'] button:first-child`,
    ruleLabel: (modifierGroupId?: string) =>
      `[data-testid='modifier-group-rule-${modifierGroupId}']`,
    modifierPrice: "[data-testid^='modifier-price-']",
  },
  about: {
    aboutSection: "[data-testid='about-section']",
  },
  giftCard: {
    addGiftCardButton: "[data-testid='add-gift-card-button']",
    giftCardAmountInput: "[data-testid='gift-card-amount-input']",
    buyThisForMyselfCheckbox: "[data-testid='buy-this-for-myself-checkbox']",
    formContainer: "[data-testid='form-container']",
    giftCardCartItem: "[data-testid='gift-card-cart-item']",
    giftCardMainContainer: "[data-testid='gift-card-main-container']",
    personalMessageComponent: "[data-testid='personal-message-component']",
    recipientEmail: "[data-testid='recipient-email']",
    recipientInformationComponent:
      "[data-testid='recipient-information-component']",
    recipientName: "[data-testid='recipient-name']",
  },
  steppers: {
    quantityStepper: "[data-testid='quantity-stepper-']",
  },
  services: {
    timeSlot: "[data-testid='time-slot']",
    scheduleAppointmentButton: "[data-testid='schedule-appointment-button']",
    serviceSummaryContinue: "[data-testid='service-summary-continue']",
  },
  onloadScheduledOrderModal: {
    modal: "[data-testid='onload-scheduled-order-modal']",
  },
  loginInfoModal: {
    otpInput: "[data-testid='otp-input']",
  },
  restaurantMenu: {
    menuPageItem: "[data-testid='restaurant-menu-page-item']",
  },
};

export default pom;
